import { get, set } from 'lodash'
import { useCallback } from 'react'

export const useSaveQuestionHighlights = ({
  question,
  userWork,
  setItemHighlights,
  currentLanguage,
  isLCBView,
  isExpressGrader,
  isStudentReport,
  studentLanguagePreference,
  utaPreferredLanguage,
  stackedTranslatorCurrentLanguage,
}) => {
  if(!question) {
    return {
      highlightedContent: '',
      saveHighlights: () => {},
    }
  }
  if (isLCBView || isExpressGrader || isStudentReport) {
    currentLanguage = utaPreferredLanguage || studentLanguagePreference
  }

  if (stackedTranslatorCurrentLanguage) {
    currentLanguage = stackedTranslatorCurrentLanguage
  }

  const testItemId = question?.testItemId || question?.activity?.testItemId
  const questionId = question?.id
  const currentTestItemItemHighlights =
    isLCBView || isExpressGrader || isStudentReport
      ? userWork?.[
          `itemHighlights_${question?.activity?.testActivityId}_${testItemId}`
        ]?.itemHighlights || {}
      : userWork?.[testItemId]?.itemHighlights || {}

  const key = `${questionId}.${currentLanguage}.stimulus`

  const highlightedContent = get(currentTestItemItemHighlights, key, '')

  const saveHighlights = useCallback(
    (updatedContent) => {
      if (setItemHighlights) {
        const newHighlights = currentTestItemItemHighlights || {}
        const updatedHighlightsData = set(newHighlights, key, updatedContent)
        setItemHighlights(updatedHighlightsData)
      }
    },
    [
      setItemHighlights,
      questionId,
      currentLanguage,
      currentTestItemItemHighlights,
    ]
  )

  return {
    highlightedContent,
    saveHighlights,
  }
}
